import { createSite, safeFunctionCompilers } from '../safeFunctions/index.js';
import { ContextProgram, defaultMetadataContext } from './displaySetContext.js';
import { BUILT_IN_SERIES_FUNCTIONS } from './seriesFunctions.js';
import { splitRuleSchema } from './splitRuleSchema.js';
let activeContext = defaultMetadataContext;
export function setMetadataContext(context) {
    activeContext = context ?? defaultMetadataContext;
}
export function getMetadataContext() {
    return activeContext;
}
const programs = new WeakMap();
export function compileMetadataContext(context, options = {}) {
    const program = new ContextProgram({ ...defaultMetadataContext, ...context }, {
        seriesFunctions: {
            ...BUILT_IN_SERIES_FUNCTIONS,
            ...options.seriesFunctions,
        },
        deniedNames: options.deniedNames,
        site: createSite({
            definition: options.definition ?? 'metadata context',
            path: 'context',
        }, splitRuleSchema, safeFunctionCompilers),
    });
    if (!options.seriesFunctions && !options.deniedNames) {
        programs.set(context ?? defaultMetadataContext, program);
    }
    return program;
}
export function getMetadataContextProgram(context, options = {}) {
    const shareable = !options.seriesFunctions && !options.deniedNames;
    const cached = shareable
        ? programs.get(context ?? defaultMetadataContext)
        : undefined;
    return cached ?? compileMetadataContext(context, options);
}
function programOf(context) {
    return getMetadataContextProgram(context);
}
export function getContextValue(name, instance, context) {
    return programOf(context ?? activeContext).instanceValue(name, instance);
}
